import { CSSProperties, FC, ReactNode } from 'react';
// styles
import styles from './MessageWrapper.module.css';

interface IMessageWrapperProps {
    children: ReactNode;
    customStyles?: CSSProperties;
}

const MessageWrapper: FC<IMessageWrapperProps> = ({ children, customStyles = {} }) => {
    return (
        <div className={styles['messageContainer']} style={customStyles}>
            {children}
        </div>
    );
};

export default MessageWrapper;
